import React, { useMemo } from 'react';

// importing MyRouts where we located all of our theme
import MyRouts from './routers/routes'

//// solana wallet adapter
import { clusterApiUrl } from '@solana/web3.js';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import {
    
    PhantomWalletAdapter,
   
} from '@solana/wallet-adapter-wallets';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';


// import the styles
require('@solana/wallet-adapter-react-ui/styles.css');

function App() {
  const solNetwork = WalletAdapterNetwork.Mainnet;
    const endpoint = useMemo(() => clusterApiUrl(solNetwork), [solNetwork]);
    // initialise all the wallets you want to use
    const wallets = useMemo(
        () => [
            new PhantomWalletAdapter(),
            
        ],
        [solNetwork]
    );
  return (
    

 <ConnectionProvider endpoint={endpoint}>
 <WalletProvider wallets={wallets}> 
    <WalletModalProvider>  
        
        <div>
      <MyRouts />
    </div>
       
  </WalletModalProvider>
</WalletProvider>
</ConnectionProvider>
  );
}

export default App;